import React from 'react'
import moment from 'moment'
import styled from 'styled-components/native'
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons'
import I18n from 'APP/I18n'
import Typography from 'APP/Converse/Typography'
import { Colors } from 'APP/Themes'

const SyncContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

interface LastActivitySyncProps {
  lastSync?: string
}

const LastActivitySync: React.FC<LastActivitySyncProps> = ({ lastSync }) => (
  <SyncContainer>
    <MaterialCommunityIcon
      name="clock-time-ten-outline"
      size={16}
      color={Colors.textSecondary}
      style={{ paddingRight: 5 }}
    />
    <Typography variant="bodySmall" color="secondary">
      {lastSync
        ? I18n.t('ActiveMinutes.activitySync.lastSyncedAt', {
            timeAgo: moment.utc(lastSync).fromNow(),
          })
        : I18n.t('ActiveMinutes.activitySync.noData')}
    </Typography>
  </SyncContainer>
)

export default LastActivitySync
